import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BrandingService {
  private brandingIdSubject = new BehaviorSubject<string | null>(null);
  brandingId$ = this.brandingIdSubject.asObservable();

  setBrandingId(id: string) {
    this.brandingIdSubject.next(id);
    localStorage.setItem('brandingId', id);
  }

  loadBrandingIdFromStorage() {
    const storedId = localStorage.getItem('brandingId');
    if (storedId) {
      this.brandingIdSubject.next(storedId);
    }
  }
}
